module.exports = __webpack_public_path__ + "media/images/emblems/Bitsch-1387d98238133b0cdd5c9eaadefd83c1.png";